<template>
    <new-validation-plan-template-component @createValidationPlanTemplate="handleCreateValidationPlanTemplate" :guidelines="guidelines"  :validationParameters="validationParameters"></new-validation-plan-template-component>
</template>

<script>
import NewValidationPlanTemplateComponent from '@/components/template/NewValidationPlanTemplateComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'
import AssessmentMethodOrder from "../../valchrom/AssessmentMethodOrder";
export default {
    name: 'NewValidationPlanTemplate',
    components: {NewValidationPlanTemplateComponent},
    data: function () {
        return {
            component_url: 'experiments/templates',  
            guidelines: []          
        }
    },
    computed: {
        ...mapGetters ([
            'base_url', 'auth_header', 'validationParameters'
        ]),        
        
    },

    mounted: function() {
        this.setBreadcrumb()
        this.getGuidlines()
    },

    methods: {    
        ...mapMutations([
            'SET_BREADCRUMB'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        getGuidlines: function(){ 
            axios
                .get(
                    this.base_url+"experiments/guidelines",
                    {
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    // TODO: hotfix - hide ROB, RUG and SST
                    response.data.forEach(function(item) {
                        item.assessment_methods = item.assessment_methods.filter(
                            (am) => {
                                return !(
                                    am.code_name.startsWith("ROB:") ||
                                    am.code_name.startsWith("RUG:") ||
                                    am.code_name.startsWith("SST:")
                                )
                            }
                        )
                    });

                    this.guidelines = response.data;

                    this.guidelines.forEach((guideline)=>{
                        guideline.assessment_methods.sort((am1,am2)=>{
                            return AssessmentMethodOrder.indexOf(am1.code_name) -
                                AssessmentMethodOrder.indexOf(am2.code_name)
                        })
                    })

                    // sort array of Guidelines
                    this.guidelines.sort(function(a, b) {
                        var nameA = a.name.toUpperCase(); // ignore upper and lowercase
                        var nameB = b.name.toUpperCase(); // ignore upper and lowercase
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        
                        // names must be equal
                        return 0;
                    });

                    // console.log("this.guidelines: ", this.guidelines)
                })
                .catch(error => {
                    console.log("Something went wrong getting guidlines", error);
                });
                
        },
        handleCreateValidationPlanTemplate: function(valPlanTemplate) {
            axios
                .post(
                    this.base_url + this.component_url,
                    valPlanTemplate,
                    { 
                        headers: this.auth_header
                    }
                )
                .then(response => {
                    console.log("Validation Plan Successfully Created", response);
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Validation Plan Successfully Created`,
                        position: 'is-top',
                        type: 'is-primary'
                    })
                    this.$router.push({ name: "ValidationPlanTemplates", params: {  } });
                })
                .catch(error => {
                    this.loading = false;
                    this.$toast.open({
                        duration: 5000,
                        message: `Validation Plan was not successfully Created`,
                        position: 'is-top',
                        type: 'is-danger'
                    })
                    console.log(error.response.data); // display more meaningful error message
                });
        }
    }
}
</script>
